import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../services/api";
;
const initialState = {
  data: undefined,
  status: 'idle',
  error: undefined
};
export const fetchLatestPosts = createAsyncThunk("BLOG/fetchLatestPosts", async () => {
  try {
    const {
      data
    } = await api.get("/v2/posts?_fields=id,categories,title,slug,yoast_head_json,date,featured_media&per_page=3");
    if (data) return data;
  } catch (err) {
    return err;
  }
});
const {
  actions,
  reducer
} = createSlice({
  name: "BLOG",
  initialState,
  reducers: {
    clearBlogLatestPostsFetcher: state => {
      state.data = undefined;
      state.status = 'idle';
      state.error = undefined;
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchLatestPosts.pending, state => {
      state.data = null;
      state.status = 'pending';
    });
    builder.addCase(fetchLatestPosts.fulfilled, (state, action) => {
      state.data = action.payload;
      state.status = 'fulfilled';
    });
    builder.addCase(fetchLatestPosts.rejected, (state, action) => {
      state.data = null;
      state.error = action.payload;
      state.status = 'rejected';
    });
  }
});
export const {
  clearBlogLatestPostsFetcher
} = actions;
export default reducer;